import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=824f4d1c"
import script from "./_card.js?vue&type=script&lang=js&external"
export * from "./_card.js?vue&type=script&lang=js&external"
import style0 from "./_card.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports